import { Box, Chip, Stack, Typography } from "@mui/material";
import DataModeBadge from "./DataModeBadge";
import { useTranslation } from "react-i18next";
import { platformMockService } from "../../services/mock/platformMockService";

const MapPanel = ({ cameras = platformMockService.getMapCameras(), dataMode = { mode: "mock" } }) => {
  const { t } = useTranslation();
  const zones = t("platform.map.zones", { returnObjects: true });
  const zoneList = Array.isArray(zones) ? zones : ["Entrance", "Perfume", "Checkout", "Electronics", "Storage"];
  return (
    <Box sx={{ position: "relative", minHeight: { xs: 400, md: 520 }, border: "1px solid", borderColor: "divider", borderRadius: 1, overflow: "hidden", bgcolor: (theme) => theme.custom.surface.inset }}>
      <Box sx={{ position: "absolute", inset: 18, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
        {zoneList.map((zone, index) => (
          <Box key={zone} sx={{ position: "absolute", left: `${8 + (index % 3) * 30}%`, top: `${12 + Math.floor(index / 3) * 42}%`, width: "24%", height: "32%", border: "1px dashed", borderColor: "rgba(148,163,184,0.32)", borderRadius: 1, p: 1 }}>
            <Typography variant="caption" color="text.secondary">{zone}</Typography>
          </Box>
        ))}
        {cameras.map((camera) => (
          <Box key={camera.id} sx={{ position: "absolute", left: camera.x, top: camera.y, transform: "translate(-50%, -50%)" }}>
            <Chip label={camera.id} color={camera.status === "online" ? "success" : camera.status === "degraded" ? "warning" : "error"} size="small" sx={{ fontWeight: 600 }} />
            <Box sx={{ width: 86, height: 52, mt: 0.75, clipPath: "polygon(0 0, 100% 32%, 100% 68%, 0 100%)", bgcolor: camera.status === "online" ? "rgba(34,197,94,0.16)" : "rgba(239,68,68,0.16)", border: (theme) => `1px solid ${theme.palette.divider}` }} />
          </Box>
        ))}
      </Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1} sx={{ position: "absolute", left: 18, right: 18, bottom: 18 }}>
        <Typography variant="caption" color="text.secondary">{t("platform.map.helper")}</Typography>
        <DataModeBadge {...dataMode} />
      </Stack>
    </Box>
  );
};

export default MapPanel;
